// extracted by mini-css-extract-plugin
export default {"wrapper":"xolZkjRD1OTkJ2AtHNhH","checkboxWrapper":"F0RgyM34PRTRx96nX37G"};